import React from 'react';

import { DropdownTimezoneButton } from '.';

type Props = {
  subtitle?: string;
  tz?: React.ComponentProps<typeof DropdownTimezoneButton>['tz'];
} & React.PropsWithChildren;

export const DropdownTimezoneItem: React.FC<Props> = ({ children, subtitle, tz }) => (
  <DropdownTimezoneButton tz={tz}>
    <div className="dropdown-timezone__item">
      <span className="dropdown-timezone__item-title">{children}</span>
      {subtitle && <span className="dropdown-timezone__item-subtitle">{subtitle}</span>}
    </div>
  </DropdownTimezoneButton>
);
